import { logEvent } from "@uikit/service/amplitude";
import { HomeUsePluginUtil } from "@uikit/util/HomeUsePluginUtil";
import { useModal } from "@uiview/views/AModal/useModal";
import {
  getHTMLElementOfReactFlow,
  getScreenshotAsBlobByHtmlElement,
  uploadFileToS3,
} from "@views/thinking-layout-editor/utilities";
import { useDispatch, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fotActions } from "../store/fot";
import { studioActions } from "../store/studio";
import func from "@uikit/func";
import { NEW_EDGE_REG, NEW_LINE_REG } from "../views/thinking-layout-editor/constants";
import { useHomeUsePluginContainer } from "./HomeUsePluginRoot/container";
import { usePreviewAppStore } from "./HomeUsePluginRoot/usePreviewAppStore";
import useCreateProject from "./useCreateProject";
import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import usePublishProject from "./usePublishProject";

const noSaveDataAttrs = ["errorText"];

export default function useHandleSave({
  newEdgeDataRef,
  showMyModification,
  getHomeNodes,
  getHomeEdges,
  getHomeNodesIndex,
  getHomeEdgesIndex,
  getSimpleNode,
  getSimpleEdge,
  getSimpleNodeV3,
  getSimpleEdgeV3,
  getFilterDataAttrsNode,
  getUIListParam,
  getItemRelavantFunctions,
  saveAsExistingTemplateV2,
  saveProject,
  resetUndoData,
  genLink,
  getItemRelavantFunctionsV3,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showModal = useModal();
  const store = useStore();
  const { gql } = useObjectRelationGqlRequest();

  const { assignPreviewAppData } = usePreviewAppStore();

  const setSelectedTemplate = val => {
    dispatch(studioActions.setSelectedTemplate(val));
  };

  const setStudioProjectName = val => {
    dispatch(fotActions.setStudioProjectName(val));
  };

  const { createProject } = useCreateProject();
  const { publishProject, updateObject } = usePublishProject({ assignPreviewAppData });
  const { isNewEdgeRunRef } = useHomeUsePluginContainer();
  const { updateCurrentProjectSavedPreviewList } = usePreviewAppStore();

  const handleReloadTip = async queryParam => {
    return new Promise(resolve => {
      showModal({
        title: "Warning",
        width: 520,
        subTitle: "Your project may have been updated, and you need to re-load the page to get the latest data.",
        buttons: ["Cancel", "Confirm"],
        onOk: ({ close }) => {
          close();
          resolve(false);
          // 这里重新定向到index参数确保share project不使用id查询到旧的数据
          navigate(`/editor/${queryParam.attrIndexer}`);
          setTimeout(() => {
            window.location.reload();
          }, 100);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  };
  const getSaveData = (templateObj, edges, variableList, params) => {
    let UI = getUIListParam();
    const nodes = getHomeNodes();
    const nodeArr = nodes.map(getSimpleNode).map(x => getFilterDataAttrsNode(x, noSaveDataAttrs));
    const edgeArr = edges.map(getSimpleEdge);
    const relevantFunctionList = getItemRelavantFunctions();
    // 简化上传参数
    const simplifySingleFlowEdgeArr = relevantFunctionList.map(x => {
      const newEdgeArr = x.edgeArr.map(getSimpleEdge);
      return {
        ...x,
        edgeArr: newEdgeArr,
      };
    });
    UI = UI.map(x => {
      x.input = x.input.map(input => {
        return {
          ...input,
          data: HomeUsePluginUtil.getDeleteFunctionData(input.data),
        };
      });
      return x;
    });
    const tempData = {};
    const defaultInit = {
      version: 1,
      nodes: nodeArr,
      edges: edgeArr,
      functions: simplifySingleFlowEdgeArr,
      UI,
      nodeIndex: getHomeNodesIndex(),
      edgeIndex: getHomeEdgesIndex(),
      variablesList: JSON.stringify(variableList),
    };

    if (params?.published_metadata) {
      tempData.published_metadata = params.published_metadata;
    }
    const v2 = Object.assign({}, templateObj.v2, defaultInit);
    tempData.v2 = v2;
    const data = Object.assign({}, { ...templateObj }, tempData);
    delete data.id;
    delete data.uuid;
    return data;
  };
  const getSaveDataV3 = (templateObj, edges, variableList, params, updateParam) => {
    let UI = getUIListParam();
    let nodes = getHomeNodes();

    if (!func.isEmpty(updateParam)) {
      nodes = nodes.map(x => {
        if (x.id === updateParam.id) {
          if (updateParam.type === "lineParam") {
            return {
              ...x,
              data: {
                ...x.data,
                lineParam: {
                  ...x.data.lineParam,
                  ...updateParam.lineParam,
                },
              },
            };
          }
          return x;
        }
        return x;
      });
    }
    const nodeArr = nodes
      .map(x => {
        if (NEW_EDGE_REG.test(x.id)) {
          return HomeUsePluginUtil.getSimpleNodeV3(x, newEdgeDataRef);
        }
        return getSimpleNode(x);
      })
      .map(x => getFilterDataAttrsNode(x, noSaveDataAttrs));
    const edgeArr = edges.map(x => {
      if (NEW_LINE_REG.test(x.id)) {
        return getSimpleEdgeV3(x);
      }
      return getSimpleEdge(x);
    });
    const relevantFunctionList = getItemRelavantFunctionsV3();
    // 简化上传参数
    const simplifySingleFlowEdgeArr = relevantFunctionList.map(x => {
      const newEdgeArr = x.edgeArr.map(getSimpleEdge);
      return {
        ...x,
        edgeArr: newEdgeArr,
      };
    });
    UI = UI.map(x => {
      x.input = x.input.map(input => {
        return {
          ...input,
          data: HomeUsePluginUtil.getDeleteFunctionData(input.data),
        };
      });
      return x;
    });

    const tempData = {};
    const defaultInit = {
      version: 1,
      nodes: nodeArr,
      edges: edgeArr,
      functions: simplifySingleFlowEdgeArr,
      UI,
      nodeIndex: getHomeNodesIndex(),
      edgeIndex: getHomeEdgesIndex(),
      variablesList: JSON.stringify(variableList),
    };

    if (params?.published_metadata) {
      tempData.published_metadata = params.published_metadata;
    }
    const v3 = Object.assign({}, templateObj.v3, defaultInit);
    tempData.v3 = v3;
    const data = Object.assign({}, { ...templateObj }, tempData);
    delete data.id;
    delete data.uuid;
    return data;
  };
  const saveAsNewTemplateV2 = async (data, notShowSuccessTip) => {
    try {
      const res = await createProject(data);
      navigate(`/editor/${res.uuid}`);
      return res;
    } catch (error) {
      func.messageError(error || "Create new project failed");
      return Promise.reject(error);
    }
  };

  // TODO: refactor
  const updateProjectBackground = data => {
    const id = store.getState().studio.selectedTemplate.id;
    return gql.mutation.updateObject(
      id,
      {
        name: "studio_project",
        attributes: data,
      },
      null
    );
  };

  const handleSave = async ({
    templateObj = store.getState().studio.selectedTemplate,
    edges = getHomeEdges(),
    shareObj = undefined,
    variableList = store.getState().fot.variableList,
    params = {},
    showPublishTips = true,
    source, //records where the save events comes from: save/home/title/share
    uiObj = {},
    notShowSuccessTip = false,
    background = false,
    local = false,
  } = {}) => {
    let res = {
      updated_project: {},
      shared_project: {},
    };
    try {
      const isFirstCreatePorject = func.isEmpty(templateObj.id);
      let data = isNewEdgeRunRef.current
        ? getSaveDataV3(templateObj, edges, variableList, params)
        : getSaveData(templateObj, edges, variableList, params);

      if (!func.isEmpty(uiObj)) {
        data = isNewEdgeRunRef.current
          ? { ...data, v3: { ...data.v3, UI: uiObj } }
          : { ...data, v2: { ...data.v2, UI: uiObj } };
      }
      // 可能不需要发布, 但是每次保存需要注入最新的 activeAppId
      data = assignPreviewAppData(data);
      // only needs to update local project data
      if (local) {
        setSelectedTemplate(data);
        updateCurrentProjectSavedPreviewList();
        return data;
      }

      // 新建
      if (isFirstCreatePorject && !showMyModification) {
        res.updated_project = await saveAsNewTemplateV2(data, notShowSuccessTip);
        setStudioProjectName(res.updated_project.name);
      } else {
        // update project in the backgroud using updateObject
        if (background) {
          res.updated_project = await updateProjectBackground(data);
          updateCurrentProjectSavedPreviewList();
          return res;
        }
        if (!showMyModification) {
          // 先获取一次对比project是否最新
          const queryParam = {};
          const queryIdKeys = [
            {
              templateKey: "index",
              paramKey: "attrIndexer",
            },
            {
              templateKey: "uuid",
              paramKey: "attrIndexer",
            },
          ];
          // 优先使用index，uuid备选
          queryIdKeys.some(x => {
            const templateId = templateObj[x.templateKey];
            if (!func.isEmpty(templateId)) {
              queryParam[x.paramKey] = templateId;
              return true;
            }
            return false;
          });
          // 查询
          const currProjectRes = await gql.query.objectSet(queryParam);
          const currProject = currProjectRes?.[0] || {};
          // 显示提示刷新弹窗
          if (!func.isEmpty(currProject) && templateObj.id !== currProject.id) {
            const isContinue = await handleReloadTip(queryParam);
            if (!isContinue) return;
          }
        }

        try {
          const element = getHTMLElementOfReactFlow();
          const blob = await getScreenshotAsBlobByHtmlElement(element);
          const file = new File([blob], data.index, { type: "image/png" });
          const uploadedResult = await uploadFileToS3(file);
          data.thumbnail_s3ObjectKey = uploadedResult.s3.object_key;
        } catch (error) {
          console.error(error);
        }
        // 更新保存
        res.updated_project = await saveAsExistingTemplateV2(templateObj, edges, data);
      }

      if (!func.isEmpty(shareObj) && shareObj.share && !showPublishTips) {
        let shareLink = shareObj.shareLink;
        const reData = isFirstCreatePorject ? res.updated_project : data;
        const sharedProject = await publishProject(reData, res.updated_project);
        res.shared_project = sharedProject;

        if (func.isEmpty(shareLink)) {
          shareLink = await genLink(sharedProject?.index, sharedProject.uuid);
        }
        const updateProject = await updateObject(reData, sharedProject, shareLink, res.updated_project.id);
        res.updated_project = updateProject;
      }

      resetUndoData();
      if (!showMyModification) {
        setSelectedTemplate(res.updated_project);
        const eventProperties = {
          project_static_id: res.updated_project.index,
          name: res.updated_project.name, //new name
          isFirstCreatePorject: isFirstCreatePorject,
          source: source, //TODO: share also auto saves
        };
        // console.log(eventProperties);
        logEvent("save_project", eventProperties);
      }
    } catch (error) {
      console.error("handle Save", error);
      return Promise.reject(error);
    }
    updateCurrentProjectSavedPreviewList();
    return res;
  };

  return {
    saveAsNewTemplateV2,
    handleSave,
    getSaveData: isNewEdgeRunRef.current ? getSaveDataV3 : getSaveData,
    getSaveDataV3,
  };
}
